import { CForm, CFormInput, CFormLabel, CFormSelect, CFormTextarea, CInputGroup } from "@coreui/react";
import { ChangeEvent, useState } from "react";
import { t } from 'i18next';
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useNavigate } from 'react-router';
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { CardLinkModel } from "@models/card-link.model";
import { handleDefaultImgClick, isValidUrl } from "@webkit/functions/utils";
import { getToastStore } from "@utils/ToastStore";
import cardLinkService from "@services/cardLink.service";
import { errorToast, successToast } from "@webkit/functions/utils";
import ImageCarousel from "@webkit/components/typescript/DefaultImagesCarousel";

export default function CardLinkPage() {
  const ctxToast = getToastStore();
  const location = useLocation();
  const { showSpinner, hideSpinner } = useSpinner();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  /* const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');
  const [currency, setCurrency] = useState('Euro'); */
  // const [linkProtocol, setLinkProtocol] = useState('https://');
  const [link, setLink] = useState('');
  const [details, setDetails] = useState('');
  const [fullAddress, setFullAddress] = useState('');
  const formData = new FormData();

  //campi per caricamento immagine e preview
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  //campi per la distanza
  const [distanceValue, setDistanceValue] = useState('');
  const [distanceUnit, setDistanceUnit] = useState('km'); // default km

  const [recommended, setRecommended] = useState(false);


  const isDisabled = (
    !title
    || !link
    || !selectedFile
  );


  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    const maxSize = 5 * 1024 * 1024;
    if (file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png" && file.type !== "image/jpg") {
        errorToast(ctxToast, t("error.invalid_image_format"));
        e.target.value = "";
        return;
      }
      if (file.size > maxSize) {
        errorToast(ctxToast, t("error.too_large"));
        e.target.value = "";
        return;
      }
      setSelectedFile(file)
      // crea un’anteprima temporanea
      const previewUrl = URL.createObjectURL(file)
      setPreview(previewUrl)
      formData.append('img', file);
    }
  };

  const handleSubmit = async () => {

    //Controllo verifica minPrice e maxPrice siano interi
    const isInteger = (value: string) => {
      // Consente solo cifre intere positive (nessun punto o virgola)
      return /^[0-9]+$/.test(value);
    };

    /* if (!isInteger(minPrice) || !isInteger(maxPrice)) {
      alert(t('error.invalid_format_min_max_price'));
      return;
    }

    // Controllo minPrice ≤ maxPrice
    if (parseInt(minPrice) > parseInt(maxPrice)) {
      alert(t('error.min_price_greater_than_max'));
      return;
    } */

    if (!isValidUrl(link)) {
      errorToast(ctxToast, t('error.invalid_link'));
      return;
    }


    //controllo sulla distanza
    if (!!distanceValue && isNaN(Number(distanceValue)) && Number(distanceValue) < 0) {
      errorToast(ctxToast, t('validation.invalid_distance'));
      return;
    }

    try {
      showSpinner();
      if (!selectedFile) {
        return;
      }
      formData.append('img', selectedFile);
      const segments = location.pathname.split('/').filter(Boolean);
      const IdAccomodation = segments.at(1) ?? '';
      const IdParent = segments.at(2) ?? '';
      let distanceCombined = "";
      if (!!distanceValue) {
        distanceCombined = `${distanceValue} ${distanceUnit}`;
      }
      const model = new CardLinkModel(title.trim(), distanceCombined, link.trim(), recommended, details, fullAddress);
      await cardLinkService.createCardLink(IdParent, formData, model);
      successToast(ctxToast, t("success.updated"));
      navigate(`/new-app/${IdAccomodation}`);
    } catch (error: any) {
      console.error('errore nella chiamata di creazione card Text', error);
    } finally {
      hideSpinner();
    }
  };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div className="card shadow-lg" style={{ width: '60%', borderRadius: '25px' }}>
        <div
          className="hst-card-header card-header text-uppercase d-flex align-items-center"
          style={{ justifyContent: 'center', position: 'relative' }}
        >
          {/* Titolo centrato */}
          <div>{t('title.create_cardlink')}</div>

        </div>

        <div className="card-body">
          <CForm className="p-5">
            <CFormInput
              type="text"
              label={`${t('label.icon_name')} ${t('placeholder.obligatory')}`}
              className="mb-3"
              value={title}
              onChange={(e) =>
                setTitle(e.target.value)
              }
            />
            <div className="mb-3">
              <CFormLabel htmlFor="distance">{t('label.distance')}</CFormLabel>

              <CInputGroup id="distance">
                <CFormInput
                  className="hst-input-distance-cardlink"
                  type="number"
                  placeholder="0"
                  value={distanceValue}
                  min="0"
                  step="1"               // solo numeri interi
                  onChange={(e) => setDistanceValue(e.target.value)}
                />

                <CFormSelect
                  className="hst-select-distance"
                  value={distanceUnit}
                  onChange={(e) => setDistanceUnit(e.target.value)}
                  style={{
                    maxWidth: '120px'

                  }}
                >
                  <option value="km">{t('label.km')}</option>
                  <option value={t('label.mi')}>{t('label.mi')}</option>
                  <option value={t('label.minutes')}>{t('label.minutes')}</option>
                </CFormSelect>
              </CInputGroup>
            </div>
            {/* <CRow>
              <CCol xs={1} />
              <CCol xs={3}>
                <CFormInput
                  type="number"
                  label={`${t('label.minPrice')} *`}
                  className="mb-3"
                  min="0"
                  step="1"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                />
              </CCol>

              <CCol xs={3}>
                <CFormInput
                  type="number"
                  label={`${t('label.maxPrice')} *`}
                  className="mb-3"
                  min="0"
                  step="1"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                />
              </CCol>
              <CCol xs={4}>
                <CFormSelect
                  label={`${t('label.currency')} *`}
                  className="mb-3"
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                >
                  {Currencies.map(({ code, symbol, label }) => (
                    <option key={code} value={label}>
                      {`${code} (${symbol}) - ${label}`}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
              <CCol xs={1} />
            </CRow> */}
            {/* Stellina a destra */}
            <div
              className="d-flex align-items-center mb-2"
            >
              <CFormLabel className="me-1 mb-0">{t('label.recommended')}</CFormLabel>
              <span
                onClick={() => setRecommended(!recommended)}
                style={{
                  cursor: 'pointer',
                  fontSize: '2rem',
                  color: recommended ? '#FFD700' : '#ccc',
                  transition: 'color 0.3s ease',
                }}
                title={
                  recommended
                    ? t('tooltip.recommended_true')
                    : t('tooltip.recommended_false')
                }
              >
                ★
              </span>
            </div>
            <CFormLabel htmlFor="link">{t('label.insert_link')} {t('placeholder.obligatory')}</CFormLabel>
            <CInputGroup className="mb-3">
              {/* <CFormSelect
                className="hst-select-link"
                value={linkProtocol}
                onChange={(e) => setLinkProtocol(e.target.value)}
                style={{ maxWidth: '120px' }}
              >
                <option value="https://">https://</option>
                <option value="http://">http://</option>

              </CFormSelect> */}

              <CFormInput
                type="text"
                placeholder="www.example.com"
                value={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </CInputGroup>
            {/* Details */}
            <CFormTextarea
              label={`${t("label.details")}`}
              rows={5}
              className="mb-4"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
            {/* fullAddress */}
            <CFormInput
              label={`${t("label.address")}`}
              className="mb-4"
              value={fullAddress}
              onChange={(e) => setFullAddress(e.target.value)}
            />
            <p className="my-4">{t('text.default_images')}</p>
            <ImageCarousel
              onImageSelect={(base64, index) =>
                handleDefaultImgClick(base64, index, setSelectedFile, setPreview, formData)
              } />

            <CFormInput
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
            {preview && (
              <div className="preview-card">
                <img
                  src={preview}
                  alt={t('label.preview')}
                  style={{ maxWidth: '200px', height: 'auto' }}
                />
              </div>
            )}

          </CForm>

          <div
            className="bg-transparent"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <Button
              className="hst-btn-secondary mt-4"

              onClick={() => navigate(-1)}
            >
              {t('text.go_back')}
            </Button>
            <Button
              className="hst-btn-primary btn-primary mt-4"
              onClick={handleSubmit}
              disabled={isDisabled}
              style={{ fontWeight: "500" }}
            >
              {t('button.save')}
            </Button>

          </div>
        </div>
      </div>
    </div>
  )
};